import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonButton, IonList, IonText } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import AuthActions from 'redux/AuthRedux';
import api_v2 from 'services/api_v2';
import { encryptPhone } from 'utils/phone';
import schema from './schema';

const INITIAL_VALUES = {
  phone: '',
  password: '',
};

/* US Number format */
function isTenDigitsNumber(str) {
  return /^\d{10}$/.test(str);
}

function LoginForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const queryParams = new URLSearchParams(useLocation().search);

  const handleSubmit = async (values, actions) => {
    try {
      const api = api_v2();
      const data = {
        phone: `+1${values.phone}`,
        password: values.password,
      };
      const { token, user } = await api.login(data);
      dispatch(AuthActions.setUser(user));
      dispatch(AuthActions.login(token));

      dispatch(
        AppActions.setToast('You have logged in successfully', 'success')
      );
    } catch (e) {
      dispatch(AppActions.setToast(e.message || 'Password is wrong', 'danger'));
    }

    actions.setSubmitting(false);
  };

  const handleForgotPassword = async () => {
    try {
      const data = {
        phone: queryParams.get('phone') || '',
        type: 'reset',
      }; /* this can be either phone or username, but we always send it as phone */

      await api_v2().requestSmsCode(data);

      dispatch(
        AppActions.setToast(
          `Password reset code has been sent to ${encryptPhone(data.phone)}`,
          'success'
        )
      );
      history.push(
        `/auth/reset-password?phone=${queryParams.get('phone') || ''}`
      );
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'Failed sending password reset code',
          'danger'
        )
      );
    }
  };

  INITIAL_VALUES.phone = queryParams.get('phone') || '';

  return (
    <Formik
      initialValues={INITIAL_VALUES}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting, errors, values }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <br />
              <Field
                disabled
                strongLabel
                autocomplete="off"
                component={InputField}
                name="phone"
                type="tel"
                label="Phone number"
              />
              <IonText color="medium" className="mb-2x">
                <small>(Use format 6123334444)</small>
              </IonText>
              <br />
              <br />
              <br />
              <Field
                strongLabel
                component={InputField}
                name="password"
                type="password"
                label="Password"
              />
              <IonText
                className='link-text'
                color="medium"
                onClick={() => handleForgotPassword()}
              >
                <small>Forgot Password?</small>
              </IonText>
              <div className="mb-2x mt-5x text-center">
                <IonButton
                  className="sign-btn"
                  color="tertiary"
                  fill="solid"
                  type="submit"
                  disabled={
                    errors.phone ||
                    errors.password ||
                    !isTenDigitsNumber(values.phone) ||
                    isSubmitting
                  }
                >
                  LogIn
                </IonButton>
              </div>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default LoginForm;
